var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPerson_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 394",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h112v112H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPerson_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 450",
    fill: "none",
    d: "M0 0h112v112H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "IconPerson",
    clipPath: "url(#IconPerson_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 418",
    fill: "#040000",
    clipPath: "url(#IconPerson_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 744",
    d: "M56.001 9.333A24.609 24.609 0 1080.61 33.942 24.61 24.61 0 0056.001 9.333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 745",
    d: "M86.618 74.629a35.082 35.082 0 00-25.154-10.608H50.531a35.083 35.083 0 00-25.15 10.608 35.9 35.9 0 00-10.3 28.037h81.833a35.9 35.9 0 00-10.3-28.037"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/IconPerson.e360cd156c239f3a.svg";
export { ForwardRef as ReactComponent };